<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageShell from '@/Components/UI/PageShell.vue'
import UiCard from '@/Components/UI/UiCard.vue'
import { useI18n } from 'vue-i18n'
import { useCurrency } from '@/composables/useCurrency.js'

defineOptions({ layout: AppLayout })
const { t } = useI18n()
const { formatMoney, formatDate, formatDateTime } = useCurrency()

defineProps({
  driver: { type: Object, required: true },
  payout: { type: Object, required: true },
})
</script>

<template>
  <PageShell
    :title="`${t('drivers.payouts.show.title')} — ${formatMoney(payout.amount_cents)}`"
    :back-href="`/drivers/${driver.id}`"
    :back-label="driver.name"
  >
    <UiCard>
      <dl class="grid grid-cols-2 gap-3 text-sm">
        <div>
          <dt class="text-[color:var(--muted)]">{{ t('drivers.payouts.show.amount') }}</dt>
          <dd class="fw-value tabular-nums mt-0.5 text-[color:var(--ink)]">{{ payout.amount }}</dd>
        </div>
        <div>
          <dt class="text-[color:var(--muted)]">{{ t('drivers.payouts.show.method') }}</dt>
          <dd class="fw-value mt-0.5 text-[color:var(--ink)]">{{ payout.method }}</dd>
        </div>
        <div>
          <dt class="text-[color:var(--muted)]">{{ t('drivers.payouts.show.paidAt') }}</dt>
          <dd class="fw-value mt-0.5 text-[color:var(--ink)]">{{ formatDateTime(payout.paid_at) }}</dd>
        </div>
        <div v-if="payout.notes">
          <dt class="text-[color:var(--muted)]">{{ t('drivers.payouts.show.notes') }}</dt>
          <dd class="mt-0.5 text-[color:var(--ink)]">{{ payout.notes }}</dd>
        </div>
      </dl>
    </UiCard>

    <UiCard :title="t('drivers.payouts.show.deliveries')">
      <ul class="divide-y" style="border-color: var(--line);">
        <li
          v-for="d in payout.deliveries"
          :key="d.id"
          class="flex justify-between py-2 text-sm"
        >
          <span class="text-[color:var(--inkSoft)]">
            {{ d.kind === 'handover' ? 'Handover' : 'Pickup' }}
            · {{ formatDate(d.scheduled_for) }}
            <template v-if="d.address"> · {{ d.address }}</template>
          </span>
          <span class="fw-value tabular-nums text-[color:var(--ink)]">{{ formatMoney(d.fee_cents) }}</span>
        </li>
      </ul>
    </UiCard>
  </PageShell>
</template>
